import script from "./UserAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./UserAvatar.vue?vue&type=style&index=0&id=21918ed9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21918ed9"]])

export default __exports__